import React, { useState, useEffect } from "react";
// import { Carousel } from "antd";
import { Carousel } from "react-responsive-carousel";

// Styles
import { Item, SelectionWrapper, Selection, Wrapper } from "./styles";

// Assets
import Cylinder from "../../assets/svgs/cylinder";
import Triangle from "../../assets/svgs/triangle";
import Tube from "../../assets/svgs/tube";
import Torus from "../../assets/svgs/torus";
import Rectangle from "../../assets/svgs/rectangle";
import Rhomboid from "../../assets/svgs/rhomboid";

const figureIndex = type => {
  const index = { cylinder: 0, torus: 1, rectangle: 2, rhomboid: 3 };

  return index[type];
};

const Car = ({ defaultValue = "cylinder", onChange }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    setCurrentSlide(figureIndex(defaultValue));
  }, [defaultValue]);

  const RenderItem = ({ item, children, itemName }) => {
    const handleClick = () => {
      setCurrentSlide(item);
      onChange(itemName);
    };
    return (
      <Selection onClick={handleClick} isSelected={currentSlide === item}>
        {children}
      </Selection>
    );
  };

  return (
    <Wrapper>
      <Carousel
        showArrows={false}
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
        width={"100%"}
        selectedItem={currentSlide}
        onChange={setCurrentSlide}
      >
        <Item>
          <Cylinder size={150} />
        </Item>
        <Item>
          <Torus size={150} />
        </Item>
        <Item>
          <Rectangle size={120} />
        </Item>
        <Item>
          <Rhomboid size={120} />
        </Item>
        <Item>
          <Tube size={120} />
        </Item>
      </Carousel>
      <SelectionWrapper>
        <RenderItem item={0} itemName={"cylinder"}>
          <Cylinder size={20} />
        </RenderItem>
        <RenderItem item={1} itemName={"torus"}>
          <Torus size={20} />
        </RenderItem>
        <RenderItem item={2} itemName={"rectangle"}>
          <Rectangle size={17} />
        </RenderItem>
        <RenderItem item={3} itemName={"rhomboid"}>
          <Rhomboid size={17} />
        </RenderItem>
        <RenderItem item={4} itemName={"tube"}>
          <Tube size={17} />
        </RenderItem>
      </SelectionWrapper>
    </Wrapper>
  );
};
export default Car;
